import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { GridsterModule } from 'angular-gridster2';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { PipesModule } from '../../../pipes/pipes.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { ProjectPopUpComponent } from './project-popup.component';
import { UserProjectsComponent } from './user-projects.component';
import { UserProjectsService } from './user-projects.service';
import { ProgressBarModule } from 'primeng/progressbar';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SkeletonModule } from 'primeng/skeleton';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { A11yModule } from '@angular/cdk/a11y';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/");
}

@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        OverlayPanelModule,
        MultiSelectModule,
        SkeletonModule,
        CardModule,
        ProgressBarModule,
        GridsterModule,
        CalendarModule,
        InputNumberModule,
        InputSwitchModule,
        InputTextModule,
        RippleModule,
        TableModule,
        DropdownModule,
        CheckboxModule,
        TooltipModule,
        ChartModule,
        ReactiveFormsModule,
        FormsModule,
        FileUploadModule,
        PipesModule,
        TagModule,
        ButtonModule,
        TranslateModule,
        A11yModule,
        ToastrModule.forRoot({
            timeOut: 2500,
            enableHtml: true,
            positionClass: 'toast-top-right'
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        UserProjectsComponent,
        ProjectPopUpComponent
    ],
    providers: [
        UserProjectsService
    ],
    exports: [
        UserProjectsComponent,
        ProjectPopUpComponent
    ],
})

export class UserProjectsModule {

}
